module.exports = __webpack_public_path__ + "static/media/play-player-intro.3f573fb0.png";